import { CommunicationStatsSummary } from '../CommunicationStatsSummary'
import { CallAttemptsCard } from './CallAttemptsCard'
import { CommunicationStatsCard } from './CommunicationStatsCard'
import { ContactRate } from './ContactRate'
import { OverallStatsCard } from './OverallStatsCard'

export const CommunicationContent = () => {
   return (
      <div className="mt-4">
         <div className="flex flex-col gap-4 mb-4 xl:flex-row">
            <div className="xl:w-1/2">
               <OverallStatsCard />
            </div>
            <div className="flex flex-col gap-4 xl:w-1/2">
               <CallAttemptsCard />
               <ContactRate />
            </div>
         </div>
         <div className="flex flex-col gap-4 mb-4 xl:flex-row">
            <CommunicationStatsCard />
         </div>
         <div className="flex flex-col gap-4 xl:flex-row">
            <CommunicationStatsSummary />
         </div>
      </div>
   )
}
